/** Closed ```mermaid … ``` fence (LF or CRLF after the language tag). */
export const MERMAID_FENCE_RE = /```\s*mermaid\s*\r?\n([\s\S]*?)```/gi

export const HTML_PREVIEW_FENCE_RE = /```\s*html\s*\r?\n([\s\S]*?)```/

/** HTML + mermaid alternation; mermaid arm uses `MERMAID_FENCE_RE.source` so one definition. */
export const HTML_OR_MERMAID_PREVIEW_FENCE_RE = new RegExp(
  `${HTML_PREVIEW_FENCE_RE.source}|${MERMAID_FENCE_RE.source}`,
  'gi',
)

export const HTML_PREVIEW_FENCE_INDEX_RE = /```\s*html\s*\r?\n([\s\S]*?)```/gi

/** Global variant of `HTML_PREVIEW_FENCE_RE` for counting all closed ```html fences. */
export const HTML_FENCE_GLOBAL_RE = new RegExp(
  HTML_PREVIEW_FENCE_RE.source,
  'gi',
)

/** Max “fix this Mermaid” chat messages per preview session (from the Fix chart action). */
export const MERMAID_AUTO_FIX_MAX = 2
